document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.tab-content');
  const tabsButton = document.getElementById('tabs-button');
  const tabsDropdown = document.getElementById('tabs-dropdown');
  const cartInfo = document.getElementById('cart-info');
  const cartCount = document.getElementById('cart-count');

  // Update cart count on page load
  updateCartCount();

  // Asignación de eventos a las pestañas
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const target = this.getAttribute('data-tab');
      
      tabs.forEach(t => t.classList.remove('active'));
      tabContents.forEach(tc => tc.classList.remove('current'));
      
      this.classList.add('active');
      document.getElementById(target).classList.add('current');
      
      if (window.innerWidth <= 768) {
        tabsDropdown.style.display = 'none';
        tabsButton.textContent = this.textContent;
      }
    });
  });

  // Acción para el botón de las pestañas en dispositivos móviles
  tabsButton.addEventListener('click', function () {
    const isDropdownVisible = tabsDropdown.style.display === 'block';
    tabsDropdown.style.display = isDropdownVisible ? 'none' : 'block';
  });

  // Acción para añadir productos al carrito
  document.querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', function () {
      const productId = this.getAttribute('data-product-id');
      const variantSelect = this.previousElementSibling;
      const variantId = variantSelect ? variantSelect.value : null;

      const formData = new FormData();
      formData.append('id', variantId || productId);
      formData.append('quantity', 1);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(data => {
        window.refreshCart(); // Asegúrate de que la función de actualización del carrito sea llamada aquí
        alert('Producto añadido al carrito');
      })
      .catch(error => console.error('Error:', error));
    });
  });

  // Función para actualizar el conteo del carrito
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        cartCount.textContent = data.item_count;
      })
      .catch(error => console.error('Error:', error));
  }

});
